import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  VOID3gxj6tk5isa35 as VOID,
  toString1pkumu07cwy4m as toString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  equals2au1ep9vhcato as equals,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  equals2v6cggk171b6e as equals_0,
  Unit_instance3vdlo4e4f5ggx as Unit_instance,
  ArrayList3it5z8td81qkl as ArrayList,
  to2cs3ny02qtbcb as to,
  toMutableList20rdgwi7d3cwi as toMutableList,
} from './kotlin-kotlin-stdlib.mjs';
import { get_jsGlobalThis3odmbn60utci as get_jsGlobalThis } from './korlibs-platform-root-korlibs-platform.mjs';
import {
  readAll1k0zte4qdypit as readAll,
  openAsync37anb1e84urmo as openAsync,
} from './korlibs-io-stream-root-korlibs-io-stream.mjs';
import { get_undefined2wip5bguf98cp as get_undefined } from './kotlinx-browser.mjs';
import { await3gx2tubo6ckuc as await_0 } from './kotlinx-coroutines-core.mjs';
import { asInt8Array769i4qnpoc13 as asInt8Array } from './korlibs-memory-root-korlibs-memory.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class Companion {
  constructor() {
    Companion_instance = this;
    this.ybq_1 = get_defaultHttpFetch();
  }
  *zbq(method, host, port, path, secure, headers, body, $completion) {
    return yield* this.ybq_1.zbq(method, host, port, path, secure, headers, body, $completion);
  }
}
class HttpFetchResult {
  constructor(status, statusText, headers, bodyRaw) {
    this.abr_1 = status;
    this.bbr_1 = statusText;
    this.cbr_1 = headers;
    this.dbr_1 = bodyRaw;
  }
  toString() {
    return 'HttpFetchResult(status=' + this.abr_1 + ', statusText=' + this.bbr_1 + ', headers=' + toString(this.cbr_1) + ', bodyRaw=' + toString(this.dbr_1) + ')';
  }
  hashCode() {
    var result = this.abr_1;
    result = imul(result, 31) + getStringHashCode(this.bbr_1) | 0;
    result = imul(result, 31) + hashCode(this.cbr_1) | 0;
    result = imul(result, 31) + hashCode(this.dbr_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof HttpFetchResult))
      return false;
    var tmp0_other_with_cast = other instanceof HttpFetchResult ? other : THROW_CCE();
    if (!(this.abr_1 === tmp0_other_with_cast.abr_1))
      return false;
    if (!(this.bbr_1 === tmp0_other_with_cast.bbr_1))
      return false;
    if (!equals(this.cbr_1, tmp0_other_with_cast.cbr_1))
      return false;
    if (!equals(this.dbr_1, tmp0_other_with_cast.dbr_1))
      return false;
    return true;
  }
}
class defaultHttpFetch$1 {
  *zbq(method, host, port, path, secure, headers, body, $completion) {
    var scheme = secure ? 'https' : 'http';
    var headersJsObj = {};
    var _iterator__ex2g4s = headers.p1();
    $l$loop_0: while (_iterator__ex2g4s.q1()) {
      var _destruct__k2r9zo = _iterator__ex2g4s.r1();
      var key = _destruct__k2r9zo.jm();
      var value = _destruct__k2r9zo.km();
      if (equals_0(key, 'connection', true))
        continue $l$loop_0;
      if (equals_0(key, 'content-length', true))
        continue $l$loop_0;
      headersJsObj[key] = value;
    }
    var url = scheme + '://' + host + ':' + port + path;
    var tmp = get_jsGlobalThis();
    // Inline function 'org.w3c.fetch.RequestInit' call
    var body_0 = body == null ? null : (yield* readAll(body, $completion));
    var referrer = get_undefined();
    var referrerPolicy = get_undefined();
    var mode = get_undefined();
    var credentials = get_undefined();
    var cache = get_undefined();
    var redirect = get_undefined();
    var integrity = get_undefined();
    var keepalive = get_undefined();
    var window_0 = get_undefined();
    var o = {};
    o['method'] = method;
    o['headers'] = headersJsObj;
    o['body'] = body_0;
    o['referrer'] = referrer;
    o['referrerPolicy'] = referrerPolicy;
    o['mode'] = mode;
    o['credentials'] = credentials;
    o['cache'] = cache;
    o['redirect'] = redirect;
    o['integrity'] = integrity;
    o['keepalive'] = keepalive;
    o['window'] = window_0;
    var tmp$ret$0 = (!(o == null) ? !(o == null) : false) ? o : THROW_CCE();
    var result = yield* await_0(tmp.fetch(url, tmp$ret$0), $completion);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var body_1 = asInt8Array(yield* await_0(result.arrayBuffer(), $completion));
    var rheaders = result.headers;
    var tmp_0 = Array;
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var keys = tmp_0.from(rheaders.keys());
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.n2(keys.length);
    var inductionVariable = 0;
    var last = keys.length;
    while (inductionVariable < last) {
      var item = keys[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var tmp$ret$8 = to(item, rheaders.get(item));
      destination.d2(tmp$ret$8);
    }
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = toMutableList(destination);
    // Inline function 'kotlin.collections.filterTo' call
    var destination_0 = ArrayList.p2();
    var _iterator__ex2g4s_0 = tmp0.p1();
    while (_iterator__ex2g4s_0.q1()) {
      var element = _iterator__ex2g4s_0.r1();
      if (!equals_0(element.pm_1, 'content-encoding', true) && !equals_0(element.pm_1, 'transfer-encoding', true)) {
        destination_0.d2(element);
      }
    }
    var outHeaders = destination_0;
    var tmp_1 = result.status;
    var tmp_2 = result.statusText;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return new HttpFetchResult(tmp_1, tmp_2, outHeaders, openAsync(body_1));
  }
}
//endregion
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new Companion();
  return Companion_instance;
}
function get_defaultHttpFetch() {
  _init_properties_HttpRawFetch_js_kt__twfcvf();
  return defaultHttpFetch;
}
var defaultHttpFetch;
var properties_initialized_HttpRawFetch_js_kt_h8nx03;
function _init_properties_HttpRawFetch_js_kt__twfcvf() {
  if (!properties_initialized_HttpRawFetch_js_kt_h8nx03) {
    properties_initialized_HttpRawFetch_js_kt_h8nx03 = true;
    defaultHttpFetch = new defaultHttpFetch$1();
  }
}
//region block: post-declaration
initMetadataForCompanion(Companion, VOID, VOID, [7]);
initMetadataForClass(HttpFetchResult, 'HttpFetchResult');
initMetadataForClass(defaultHttpFetch$1, VOID, VOID, VOID, VOID, [7]);
//endregion
//region block: exports
export {
  Companion_getInstance as Companion_getInstance1e9v47ur0qkb5,
};
//endregion
